module.exports = __webpack_public_path__ + "img/shangmao.354b5215.jpg";